export const ALL_NUMBERS_ACCESS = "all_owned";
export const SELECTED_NUMBERS_ACCESS = "selected";

export function normalizeScopeGroups(scopeGroups = []) {
  return (Array.isArray(scopeGroups) ? scopeGroups : [])
    .map((group) => ({
      id: String(group?.id || "").trim(),
      label: String(group?.label || "").trim(),
      description: String(group?.description || "").trim(),
      scopes: Array.isArray(group?.scopes)
        ? group.scopes.map((scope) => String(scope || "").trim()).filter(Boolean)
        : [],
    }))
    .filter((group) => group.id && group.scopes.length);
}

export function normalizeDeveloperAccessDraft(payload = {}, scopeGroups = [], accounts = [], options = {}) {
  const groups = normalizeScopeGroups(scopeGroups);
  const audioOnlyDefault = options.whatsappAccessAllowed === false;
  const defaultScopes = new Set(audioOnlyDefault
    ? groups.flatMap((group) => group.scopes).filter((scope) => scope === "audio:process")
    : groups.slice(0, 1).flatMap((group) => group.scopes));
  const payloadScopes = new Set(
    (Array.isArray(payload.scopes) ? payload.scopes : [])
      .map((scope) => String(scope || "").trim())
      .filter(Boolean),
  );
  const accountIds = new Set(
    (Array.isArray(accounts) ? accounts : [])
      .map((account) => String(account?.id || "").trim())
      .filter(Boolean),
  );
  const payloadAccountIds = (Array.isArray(payload.accountIds) ? payload.accountIds : [])
    .map((accountId) => String(accountId || "").trim())
    .filter((accountId) => accountIds.has(accountId));
  const accountAccess = payload.accountAccess === ALL_NUMBERS_ACCESS || (!payload.accountAccess && audioOnlyDefault)
    ? ALL_NUMBERS_ACCESS
    : SELECTED_NUMBERS_ACCESS;
  const selectedAccountIds = payloadAccountIds.length || options.fallbackSelectedAccount === false
    ? payloadAccountIds
    : [...accountIds].slice(0, 1);
  return {
    name: String(payload.name || "").trim(),
    accountAccess,
    accountIds: accountAccess === SELECTED_NUMBERS_ACCESS
      ? selectedAccountIds
      : payloadAccountIds,
    scopes: [...(payloadScopes.size ? payloadScopes : defaultScopes)],
  };
}

export function keyHasRevealableSecret(createPayload = {}) {
  return Boolean(String(createPayload?.apiKey || "").trim());
}

export function buildDeveloperAccessMutationBody(draft = {}) {
  return {
    name: String(draft.name || "").trim(),
    accountAccess: draft.accountAccess === SELECTED_NUMBERS_ACCESS
      ? SELECTED_NUMBERS_ACCESS
      : ALL_NUMBERS_ACCESS,
    accountIds: Array.isArray(draft.accountIds)
      ? draft.accountIds.map((accountId) => String(accountId || "").trim()).filter(Boolean)
      : [],
    scopes: Array.isArray(draft.scopes)
      ? draft.scopes.map((scope) => String(scope || "").trim()).filter(Boolean)
      : [],
  };
}

export function canSaveDeveloperAccessDraft(draft, entitlement) {
  const scopes = draft?.scopes || [];
  return scopes.length > 0 && (entitlement?.can_create_keys !== false || scopes.every((scope) => scope === "audio:process"));
}
